import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    option: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 8,
    },
    outer: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 16,
        height: 16,
        backgroundColor: Colors.transparent,
        borderRadius: 8,
        borderWidth: 1,
        margin: 0,
        marginRight: 8,
    },
    outer_isActive_true: {
        borderColor: Colors.ocean
    },
    outer_isActive_false: {
        borderColor: Colors.platinum
    },
    inner: {
        margin: 2,
        width: 10,
        height: 10,
        borderRadius: 5,
    },
    inner_isActive_true: {
        backgroundColor: Colors.ocean,
        borderRadius: 5,
    },
    inner_isActive_false: {
        // backgroundColor: Colors.platinum
    },
    label: {
        width: '90%',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },
})

export default styles
